import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useArticle } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { useI18n } from "@/lib/i18n";
import { fmtDate } from "./Blog";
import { SplitText, Reveal } from "@/components/fx/Motion";

export default function Article() {
  const { handle } = useParams();
  const { t } = useI18n();
  const { data: a, isLoading, isError } = useArticle(handle);
  useSeo(a?.title, a?.excerpt);
  if (isLoading) return <div className="max-w-3xl mx-auto px-5 py-20"><div className="h-96 bg-white/5 animate-pulse" /></div>;
  if (isError || !a) return <div className="py-32 text-center"><p className="font-display text-3xl mb-6">{t("article_not_found")}</p><Link to="/blog" className="text-gold">{t("back_journal")}</Link></div>;
  return (
    <article data-testid="article-page" className="max-w-3xl mx-auto px-5 py-14 lg:py-20">
      <Link data-testid="article-back-link" to="/blog" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold mb-10 hover:gap-4 transition-[gap]"><ArrowLeft size={14} /> {t("back_journal")}</Link>
      <p className="text-[11px] uppercase tracking-[0.2em] text-white/40">{fmtDate(a.published_at)}</p>
      <h1 data-testid="article-title" className="font-display text-4xl sm:text-5xl leading-tight mt-3 mb-10"><SplitText key={a.title} text={a.title} stagger={0.04} /></h1>
      <Reveal delay={0.3}><div className="rte" dangerouslySetInnerHTML={{ __html: a.content_html }} /></Reveal>
      <Reveal className="mt-16 border border-[#c9a55c]/30 p-8 text-center">
        <p className="font-display text-2xl mb-5">{t("article_cta_title")}</p>
        <Link data-testid="article-shop-button" to="/shop" className="btn-gold btn-shine inline-block px-10 py-4">{t("article_cta")}</Link>
      </Reveal>
    </article>
  );
}
